__webpack_require__.p = "https://boilerplate-mfe.s.plurall.net/";